import { render, staticRenderFns } from "./ArtworkHistoryDetails.vue?vue&type=template&id=f77a599c"
import script from "./ArtworkHistoryDetails.vue?vue&type=script&lang=js"
export * from "./ArtworkHistoryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports